import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import store from "@/store";

import ElementUI from "element-ui";
import "./element-theme.scss";

Vue.use(Vuex);
Vue.use(ElementUI);

import Passport from "@/components/Passport";
import UserBind from "@/components/Passport/UserBind";
import Comment from "@/components/Comment";
import Like from "@/components/Like";
import Collect from "@/components/Collect";
import Reward from "@/components/Reward";
import Usercp from "@/components/Usercp";

Vue.prototype.axios = axios;

// Vue.prototype.axios.apiGateway = "http://www.x-games-cn.com/jsapi/";
// Vue.prototype.axios.apiGateway = "http://dev.xgame.com/jsapi/";
Vue.prototype.axios.apiGateway = "/jsapi/";
Vue.prototype.axios.defaults.headers.post["Content-Type"] =
	"application/x-www-form-urlencoded";
// Vue.prototype.axios.defaults.withCredentials = true;

Vue.prototype.util = new Vue();

window.vm = new Vue({
	el: "#app",
	store,
	data: {
		user: undefined
	},
	components: {
		Passport,
		UserBind,
		Like,
		Collect,
		Reward,
		Comment,
		Usercp
	},
	methods: {
		emit(event, opts) {
			this.util.$emit(event, opts);
		}
	},
	created() {
		// 检查是否登录，并将用户信息载入
		this.$store.dispatch("notify", user => {
			this.user = user;
		});
	}
});



// WEBPACK FOOTER //
// ./src/main.js